<template>
  <div>
    <v-btn
      color="primary"
      elevation="0"
      block
      class="redeem-button"
      @click="showRedeemAlertDialog"
    >
      {{ $t('bounties.redeemInShopBountyButtonText') }}
    </v-btn>
    <promo-dialog
      v-if="showPromoDialog"
      v-bind="{fetchedBounty, showPromoDialog}"
      @finish-pressed="onFinishPressed"
    />
    <shipping-dialog
      v-bind="{bounty, showShippingDialog}"
      @finish-pressed="onFinishPressed"
    />
    <v-dialog
      v-model="redeemAlertDialog"
      persistent
      max-width="320"
    >
      <v-card>
        <v-card-title class="headline">
          {{ bounty.bounty_redeem_alert_header }}
        </v-card-title>
        <v-card-text>
          <div v-html="bounty.bounty_redeem_alert_text" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="redeemAlertDialog = false"
          >
            {{ $t('bounties.redeemAlertDialogCancel') }}
          </v-btn>
          <v-btn
            color="primary"
            text
            :loading="redeemLoading"
            @click="onRedeemClick"
          >
            {{ $t('bounties.redeemAlertDialogRedeem') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="redeemErrorDialog" max-width="320">
      <v-card>
        <v-card-title class="headline">
          {{ $t('bounties.redeemErrorDialogRedeem') }}
        </v-card-title>
        <v-card-text>
          <div v-html="redeemErrorDescription" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="redeemErrorDialog = false"
          >
            {{ $t('bounties.redeemErrorDialogClose') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import Vue from 'vue'
import {BASE_API_URL, storage} from '@/store'
import {mdiArrowLeft, mdiCartPlus} from '@mdi/js'
import PromoDialog from '@/components/bounty/PromoDialog'
import ShippingDialog from '@/components/bounty/ShippingDialog'

export default {
  name: 'RedeemBountyButton',
  components: {
    PromoDialog,
    ShippingDialog
  },
  props: {
    bounty: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      icons: {mdiArrowLeft, mdiCartPlus},
      redeemed: false,
      redeemAlertDialog: false,
      redeemLoading: false,
      redeemErrorDialog: false,
      redeemErrorDescription: '',
      showPromoDialog: false,
      fetchedBounty: null,
      showShippingDialog: false
    }
  },
  computed: {
    requireShop() {
      return this.bounty.require_shop_when_redeemed &&
        _.isEmpty(_.get(this.bounty, 'shop'))
    }
  },
  methods: {
    showRedeemAlertDialog() {
      if (this.bounty.type === 0) {
        this.redeemAlertDialog = true
      } else {
        this.onRedeemClick()
      }
    },
    async onRedeemClick() {
      if (this.bounty.shipping || this.bounty.instant) {
        this.redeemShippingBounty()
      } else {
        this.redeemInShopBounty()
      }
    },
    async redeemShippingBounty() {
      this.showShippingDialog = true
    },
    async redeemInShopBounty() {
      this.redeemLoading = true

      const bodyData = {
        bounty_id: this.bounty.id,
      }

      try {
        let response = await Vue.axios.post(
          `${BASE_API_URL}/api/v1/clients/${this.$store.state.client_id}/bounties/redeem/`,
          JSON.stringify(bodyData)
        )

        if (response.data.success) {
          this.redeemed = true
          this.redeemLoading = false

          if (_.has(response.data, 'promo_code')) {
            this.fetchedBounty = response.data.fetched_bounty
            this.showPromoDialog = true
          } else {
            const ts = Math.round(+new Date() / 1000).toString()
            storage.setItem(
              'activeVoucher',
              JSON.stringify({
                bountyId: this.bounty.id,
                voucherStart: ts
              })
            )
            this.$store.dispatch('setActiveVoucherDialog')
          }
        } else {
          this.redeemAlertDialog = false
          this.redeemErrorDialog = true

          if (
            _.has(response.data, 'code') &&
              response.data.code === 'BOUNTY_NOT_REDEEMABLE'
          ) {
            this.redeemErrorDescription =
              this.$t('bounties.redeemErrorDialogBountyNotRedeemable')
          } else {
            this.redeemErrorDescription =
              this.$t('bounties.redeemErrorDialogBountyInvalid')
          }
        }
      } catch (error) {
        this.redeemErrorDialog = true
        this.redeemErrorDescription = this.$t('bounties.redeemErrorDialogDefaultDescription')
        console.log(error)
      } finally {
        this.redeemAlertDialog = false
        this.redeemLoading = false
      }
    },
    async onFinishPressed() {
      this.showPromoDialog = false
      this.showShippingDialog = false
      await this.$store.dispatch('fetchRewardsData')
    }
  }
}
</script>

<style scoped lang="scss">
.back {
  width: 100vw;
  position: absolute;
  left: calc(50% - 50vw);
}

.redeem-button {
  ::v-deep .v-btn__content {
    width: 100%;
    white-space: normal;
  }
}
</style>
